export enum EmployeeBaseDataType {
  IDENTIFIER = 'identifier',
  GENDER = 'gender',
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  DATE_OF_BIRTH = 'dateOfBirth',
  MARITAL_STATUS = 'maritalStatus',
  NUMBER_OF_CHILDREN = 'numberOfChildren',
  HEALTH_INSURANCE_NAME = 'healthInsuranceName',
  HEALTH_INSURANCE_NUMBER = 'healthInsuranceNumber',
  NOTES = 'notes',
}
